import { API } from "aws-amplify";

export default async function getAlertNotification() {
  return await API.get("notification", "getNotificationSetting");
}
